// import * as React from 'react';
// import TextField from '@mui/material/TextField';
// import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
// import { useSelector } from 'react-redux';
// import { Controller } from 'react-hook-form';

// const filterOptions = createFilterOptions({
//   matchFrom: 'any',
//   stringify: (option) => `${option.winthor} ${option.nome}`,
// });

// export default function FuncionarAuto({ value, setValue, inputValue, setInputValue, inputRef, funcionarios,control,name }) {

//   return (
//     <Controller
//           name={name}
//       control={control}
//       defaultValue={null}
//     >
//       <Autocomplete
//         slotProps={{
//           popper: {
//             modifiers: [
//               {
//                 name: 'zIndex',
//                 enabled: true,
//                 phase: 'write',
//                 fn: ({ state }) => {
//                   state.styles.popper.zIndex = '9999';
//                 },
//               },
//             ],
//           },
//         }}
//         className="bg-white z-50  rounded-md"
//         sx={{ height: 44, border: 'none' }}
//         value={value}
//         onChange={(event, newValue) => {
//           setValue(newValue);
//         }}
//         inputValue={inputValue}
//         onInputChange={(event, newInputValue) => {
//           setInputValue(newInputValue);
//         }}
//         id="controllable-states-demo"
//         options={funcionarios}
//         getOptionLabel={(option) => option.nome}
//         isOptionEqualToValue={(option, value) => option.id === value?.id}
//         filterOptions={filterOptions}
//         renderInput={(params) => (
//           <TextField
//             inputRef={inputRef}
//             {...params}
//             placeholder="Digite o nome ou código..." // Mantém o placeholder
//             variant="outlined"
//             // Input
//             inputProps={{
//               ...params.inputProps,
//               sx: {
//                 height: 'auto', // Define a altura do input
//                 padding: '0', // Ajuste o padding para que o campo não fique com bordas muito grandes
//               },
//             }}
//             sx={{
//               '& .MuiOutlinedInput-root': {
//                 height: 44, // Controla a altura do campo de input
//               },
//             }}
//           />
//         )}
//         autoComplete="off"
//       />
//     </Controller>
//   );
// }
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import MsgInputError from '../MsgInputError';

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  stringify: (option) => `${option.winthor} ${option.nome}`,
});

export default function FuncionarioAuto({
  control,
  name,
  funcionarios,
}) {
  return (
    <>
    <Controller
      name={name}
      control={control}
      rules={{required:'Este campo é obrigatório'}}
      defaultValue={null}
      render={({ field, fieldState }) => (<>
        <Autocomplete
          {...field}
          className="bg-white z-50  rounded-md"
          options={funcionarios}
          getOptionLabel={(option) => {
          if (!option?.nome) return '';

          return option.nome
            .toLowerCase()
            .split(' ')
            .map(palavra =>
              palavra.charAt(0).toUpperCase() + palavra.slice(1)
            )
            .join(' ');
        }}
          isOptionEqualToValue={(option, value) =>
            option.id === value?.id
          }
          filterOptions={filterOptions}
          onChange={(_, newValue) => field.onChange(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
            inputProps={{
              ...params.inputProps,
              sx: {
                height: 'auto', // Define a altura do input
                padding: '0', // Ajuste o padding para que o campo não fique com bordas muito grandes
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: 44, // Controla a altura do campo de input
              },
            }}
              placeholder="Digite o nome ou código..."
              error={!!fieldState.error}
              // helperText={fieldState.error?.message}
              autoComplete="off"
            />

          )}
        />
      {!!fieldState.error && <MsgInputError text={fieldState.error?.message } />}
      </>
      )}
    />
    </>
    
  );
}
